import { type CommunityNotificationSettings, createCommunityNotificationSettings } from 'models';
import { useQuery } from 'query';

import { getNotificationSettings } from '../services';
import { getCommunityNotificationsKey } from './keys';

export const useNotificationSettingsQuery = ({ id }: { id: string }) =>
  useQuery<CommunityNotificationSettings>({
    async queryFn() {
      const { data } = await getNotificationSettings({ id });
      return createCommunityNotificationSettings(data);
    },
    queryKey: getCommunityNotificationsKey({ id }),
    // TODO this is not final solution for this problem, should be replaced in future
    refetchOnMount: 'always',
  });
